import { render, staticRenderFns } from "./ClueReport.vue?vue&type=template&id=0c76070e&scoped=true&"
import script from "./ClueReport.vue?vue&type=script&lang=js&"
export * from "./ClueReport.vue?vue&type=script&lang=js&"
import style0 from "./ClueReport.vue?vue&type=style&index=0&id=0c76070e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c76070e",
  null
  
)

component.options.__file = "ClueReport.vue"
export default component.exports